import { screens } from 'ui-components/src/styles/utils';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;

  padding: 0 0.25rem 0 0.25rem;

  ${() => ({
    [screens.sm]: {
      padding: '0 0.5rem 0 0.5rem',
    },
  })}
`;

export const Field = styled.div`
  width: 100%;
`;
